import React, { useState } from "react";
import Editor from "react-simple-code-editor";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism.css";
import "prismjs/components/prism-markup";

export default function CodeEditor({ value, onChange }) {
  return (
    <Editor
      value={value}
      onValueChange={(code) => {
        onChange(code);
      }}
      highlight={(code) => highlight(code, languages.html)}
      padding={10}
      style={{
        fontFamily: '"Fira code", "Fira Mono", monospace',
        fontSize: 12
      }}
    />
  );
}
